import { date as dateYup } from 'yup';

import { ErrorMessageTranslation } from '../types';

export const date = () =>
  dateYup().min(new Date(1900, 0, 1), {
    messageTranslation: {
      key: 'validation.minDateYear',
      options: { year: 1900 },
    },
  } as ErrorMessageTranslation);
